// in milliseconds
export const AXIOS_TIMEOUT = 30000;
